import AjaxUtil from 'common/Js/AjaxHelper/AjaxUtil';
import { UserInfoDTO } from './Models/userInfo.dto';
import { HOST_URL } from 'config';

export const getClientExpiration = async (clientToken: string) => {
  const url = `${HOST_URL}/WebApp/Customers/Expiration?clientToken=${clientToken}`;
  return AjaxUtil.sendGet(url);
};

export const getUserInfo = async (clientToken: string): Promise<UserInfoDTO> => {
  const url = `${HOST_URL}/WebApp/Customers/Information?clientToken=${clientToken}`;
  return AjaxUtil.sendGet(url);
};

export const sendContactUs = async (data: any) => {
  const url = 'https://forms.hubspot.com/uploads/form/v2/3454686/2553e8fe-aa34-47ce-b9c6-14210b382004';
  const formData = new FormData();
  for (var key in data) {
    formData.append(key, data[key]);
  }
  return fetch(url, {
    method: 'post',
    body: formData
  });
};
